import {useLocation} from 'react-router-dom';
import googleIcon from '../../../../../assets/images/auth/google.svg';
import InButtonLoader from '../../../../common/components/InButtonLoader';

interface Props {
	text: string;
	agree?: boolean;
	buttonHandler?: () => void;
	loading: boolean;
}

export default function GoogleButton({text, buttonHandler, loading, agree}: Props) {
	const {pathname} = useLocation();

	return (
		<div className='mb-6 sm:mb-3 lg:mb-6'>
			<button
				type='button'
				disabled={pathname === '/auth/register' && !agree}
				className={`w-full p-2.5 border border-black-90 rounded-4xl text-base md:text-xs lg:text-base font-medium flex justify-center h-12 ${
					agree ? 'bg-primary text-white' : 'text-black-10'
				}`}
				onClick={buttonHandler}
			>
				<img src={googleIcon} alt='google icon' className='mr-3.5 h-5 w-5 mt-[2px]' />

				<InButtonLoader isLoading={loading} showIcon showText>
					{text}
				</InButtonLoader>
			</button>
		</div>
	);
}
